import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../slices/index';
import conferenceReducer from '../features/conferenceSlice';
import userReducer  from '../features/userSlice'
import getInTouchReducer from '../features/getInTouchSlice';
import locationsReducer from '../features/locationSlice'
import amenitiesReducer from '../features/amenitySlice' 
const store = configureStore({
  reducer: {
  ...rootReducer,
  conference:conferenceReducer,
  user:userReducer,
  getInTouch: getInTouchReducer,
  locations:locationsReducer,
  amenities:amenitiesReducer
  },
});

export default store;
